function useScrollShadow(element: HTMLElement | null) {
    let listenerAdded = false

    const handleScrollShadow = (event: Event) => {
        const element = event.target as HTMLElement

        if (!element) return

        // Check if the element's content is tall enough to add any shadow
        if (element.scrollHeight < element.clientHeight) return

        // Check if the user has reached the top or bottom of the scroll
        const scrollTop = element.scrollTop
        const scrollHeight = element.scrollHeight
        const clientHeight = element.clientHeight

        if (scrollTop === 0) {
            // User has reached the top of the scroll
            element.style.boxShadow = 'inset 0 20px 20px -20px rgba(0,0,0,0.3)'
        } else if (scrollTop + clientHeight >= scrollHeight) {
            // User has reached the bottom of the scroll
            element.style.boxShadow = 'inset 0 -20px 20px -20px rgba(0,0,0,0.3)'
        } else {
            // User is somewhere in the middle
            element.style.boxShadow = 'none'
        }
    }

    const addListener = (el: HTMLElement) => {
        el.addEventListener('scroll', handleScrollShadow)
        listenerAdded = true
    }

    if (element && !listenerAdded) {
        addListener(element)
        element.style.transition = 'all .3s ease-in-out'
    }
}

export default useScrollShadow
